import type { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

interface TwoFactorAuthGuardProps {
    children: ReactNode;
}

const TwoFactorAuthGuard: FC<TwoFactorAuthGuardProps> = ({ children }) => {
    const { isAuthenticated } = useAuth();


    const is2FAEnabled = localStorage.getItem('is2FAEnabled') === 'true';
    const isOtpVerified = localStorage.getItem('isOtpVerified') === 'true';

    // if user is authenticated, redirect to dashboard
    if (isAuthenticated) {
        return <Navigate to="/cases/dashboard" />;
    }

    if (localStorage.getItem('accessToken')) {
        return <Navigate to="/cases/dashboard" />;
    }

    // Add check for missing localStorage items
    if (!is2FAEnabled && !isOtpVerified) {
        return <Navigate to="/login" />;
    }

    // if (is2FAEnabled && isOtpVerified) {
    //     return <Navigate to="/cases/dashboard" />;
    // }

    return <>{children}</>;
};

TwoFactorAuthGuard.propTypes = {
    children: PropTypes.node,
};

export default TwoFactorAuthGuard;
